import { syncGetDisplayUnitSetId } from 'plugin-assets/shared/display-units/api'

type ShallowMarkerData = {
    value: number
    originalValue?: number
    unit?: string
    widgets: {
        widgetId: number
        points: {
            name: string
            mnemonic?: string
            index?: number
        }[]
    }[]
}

interface QueryParams {
    dashboardId: number
    extra?: Record<string, unknown>
}

type ChannelWidget = {
    options: { id: number }
    context: { widget: { type: string } }
    channels: Record<string, { mnemonic: string; description: string; index?: number }>
}

export default function init(chartType: string): void {
    try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        // @TODO Plublish plugin-annotations package on NPM
        const all = window.require('plugin-annotations/shared/registries')

        all.registerWidgetForMarkers(chartType, test, beforeSaving, beforeList)
    } catch (err) {
        // err
        console.log(err)
    }
}

function test(
    data: QueryParams | ShallowMarkerData,
    widget: ChannelWidget,
    markerConfig: Record<string, unknown>
): boolean {
    return widget.context?.widget?.type === 'channels-temporal'
}

function beforeList(params: QueryParams, widget: ChannelWidget, markerConfig: Record<string, unknown>): QueryParams {
    params.extra.displayUnitSetId = syncGetDisplayUnitSetId(params.dashboardId)

    return params
}

async function beforeSaving(
    marker: ShallowMarkerData,
    widget: ChannelWidget,
    markerConfig: Record<string, unknown>
): Promise<ShallowMarkerData> {
    const widgetCurves = marker.widgets.find(a => a.widgetId === widget.options.id)

    // Associating each entry in widgetCurves.points with the corresponding channel
    if (widgetCurves) {
        const mnemonics = Object.values(widget.channels).map(a => ({ key: a.mnemonic, name: a.description, index: a.index }))

        for (const curve of widgetCurves.points) {
            const m = mnemonics.find(a => curve.name.endsWith(a.name))
            curve.mnemonic = m?.key || curve.mnemonic
            curve.index = widget.cfg.yAxis.find(a => a.__id === curve.name)?.__index
        }
    }

    if (widgetCurves.points.every(a => a.index != null)) {
        widgetCurves.points = widgetCurves.points.sort((a, b) => a.index - b.index)
    } else {
        widgetCurves.points = widgetCurves.points.sort((a, b) => a.name.localeCompare(b.name))
    }

    return marker
}
